import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import merge from 'deepmerge'
import { compactAndFilter } from '@/utils'

const module = 'regions'
let doc = {
  list: {
    name: 'Régions',
    headers: [
      { label: 'Nom', value: 'name' },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['regions.create'], dispatch: `${module}/openForm` },
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
      { icon: 'pie_chart', context: {field: 'region_id'}, dispatch: `tenancy/getTenancy` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['regions.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
      {
        label: 'Occupation',
        icon: 'pie_chart',
        dispatch: `tenancy/getMultiTenancy`,
        context: {field: 'region_id'},
      },
    ],
    search: [
      { label: 'Nom', type: 'text', name: 'name', classes: 'xs12' },
    ],
  },

  form: {
    name: 'Région',
    hasPhoto: true,
    fields: [
      { label: 'Nom', type: 'text', name: 'name', hint: 'Nom de la région' },
    ],
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['regions.update'], dispatch: `${module}/update` },
      {
        icon: 'delete',
        scope: ['regions.delete'],
        isFlat: true,
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
      { icon: 'search', isFlat: true, filter: {relation: true}, dispatch: `${module}/openRelatedSearch` },
    ],
    relations: [
      {
        name: 'Villes',
        source: 'cities',
        headers: [
          { label: 'Nom', value: 'name' },
        ],
        dispatch: 'getCities',
        dataActions: [
          { icon: 'visibility', isFlat: false, dispatch: `cities/goTo` },
        ],
      },
    ],
  },

  params: {
    fetchAll: {},
    fetchOne: {},
  },
}
const base = crudmaker(module, apiClient, doc)

const custom = {
  actions: {
    getCities: ({ commit }, payload) => {
      const { context, data } = payload
      commit('SET_LOADING', true)
      commit('cities/LIST_REQUEST', payload, {root: true})
      let compacted = compactAndFilter(data)
      let params = { ...compacted, region_id: context.id }
      apiClient.fetchCustom('cities', `cities`, params)
        .then(data => {
          commit('cities/LIST_SUCCESS', data, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('cities/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
  },
}

export default merge(base, custom)
